
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  Portfolios = {
    'has_portfolios': {
      init: function() {
        $('.loader').loader();
        var columns = [
          {
            label: '<span class="dashicons dashicons-star-filled a1"></span>',
            property: 'fave',
            width: 'auto',
            className: 'text-center',
            sortable: true
          },
          {
            label: '',
            property: 'subscription',
            width: 'auto'
          },
          {
            label: 'Portfolio',
            property: 'portfolio',
            sortable: true
          },
          {
            label: 'Category',
            property: 'category',
            className: 'text-center',
            sortable: true
          },
          {
            label: 'Current Holdings',
            property: 'current_holdings',
            className: 'text-center',
            sortable: true
          },
          {
            label: 'Current Cash Position',
            property: 'current_cash_position',
            className: 'text-center',
            sortable: true
          },
          {
            label: 'YTD Return',
            property: 'ytd_return',
            className: 'text-center',
            sortable: true
          },
          {
            label: '1 Year Return',
            property: 'one_year_return',
            className: 'text-center',
            sortable: true
          },
          {
            label: '5 Year Return',
            property: 'five_year_return',
            className: 'text-center hidden-xs',
            sortable: true
          },
          {
            label: 'Annualized Return',
            property: 'annualized',
            className: 'text-center',
            sortable: true
          },
          {
            label: 'Return Since Inception',
            property: 'return_since_inception',
            className: 'text-center',
            sortable: true
          },
          {
            label: 'Orders',
            property: 'orders',
            className: 'text-center',
            sortable: true
          }
        ];

        var items = [];

        var json;

        function customColumnRenderer(helpers, callback) {
          // determine what column is being rendered
          var column = helpers.columnAttr;

          // get all the data for the entire row
          var rowData = helpers.rowData;
          var customMarkup = '';

          // only override the output for specific columns.
          // will default to output the text value of the row item
          var url = rowData.url;
          switch(column) {
            case 'fave':
              customMarkup = helpers.item.html();
              break;
            case 'subscription':
              helpers.item.addClass('subscription');
              customMarkup = '<a href="' + url + '"><span class="icon-' + helpers.item.text() + '"></span></a>';
              break;
            case 'portfolio':
              helpers.item.addClass('portfolio-name');
              customMarkup = '<a href="' + url + '">' + rowData.portfolio + '</a>';
              break;
            case 'category':
              helpers.item.addClass('category').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + helpers.item.text() + '</a>';
              break;
            case 'current_cash_position':
              helpers.item.addClass('current-cash-position').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + rowData.current_cash_position + '%</a>';
              break;
            case 'ytd_return':
              helpers.item.addClass('ytd-return').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + rowData.ytd_return + '%</a>';
              break;
            case 'one_year_return':
              helpers.item.addClass('one-year-return').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + rowData.one_year_return + '%</a>';
              break;
            case 'five_year_return':
              helpers.item.addClass('five-year-return').addClass('text-center hidden-xs');
              customMarkup = '<a href="' + url + '">' + rowData.five_year_return + '%</a>';
              break;
            case 'annualized':
              helpers.item.addClass('annualized').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + rowData.annualized + '%</a>';
              break;
            case 'return_since_inception':
              helpers.item.addClass('return-since-inception').addClass('text-center');
              customMarkup = '<a href="' + url + '">' + rowData.return_since_inception + '%</a>';
              break;
            case 'orders':
              helpers.item.addClass('orders').addClass('text-center');
              customMarkup = '<a class="btn btn-sm btn-secondary" href="' + url + '">' + helpers.item.text() + '</a>';
              break;
            default:
              customMarkup = '<a href="' + url + '">' + helpers.item.text() + '</a>';
              break;
          }
          helpers.item.html(customMarkup);

          callback();
        }
        function customRowRenderer(helpers, callback) {
          // let's get the id and add it to the "tr" DOM element
          var item = helpers.item;
          item.attr('id', 'row' + helpers.rowData.id)
            .addClass(helpers.rowData.category.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-'))
            .addClass(helpers.rowData.portfolio.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-'));

          callback();
        }

		function get_favecookie(){
			var favecookie = $.cookie('faves');
			var cookiefaves = [];
			if( undefined !== favecookie ) {
				cookiefaves = JSON.parse( favecookie );
			}
			return cookiefaves;
		}
		function get_favedom(){
			var favedom = $('#portfolio-fave-data').data('faves');
			var domfaves = [];
			if( undefined !== favedom && favedom.length && typeof(favedom) === 'string' ) {
				domfaves = JSON.parse( favedom );
			} else if( typeof(favedom) === 'object') {
				domfaves = favedom;
			}

			return domfaves;

		}
		function pc_set_fave( portfolio ) {
			var itemindex = items.map(function(o) { return o.slug; }).indexOf(portfolio);
			var index = -1;
            var faves = get_favedom();
			if( $("span[data-portfolio='" + portfolio + "']").hasClass('a1') ) {
				$("span[data-portfolio='" + portfolio + "']").removeClass( 'a1' );
				$("span[data-portfolio='" + portfolio + "']").addClass( 'a2' );
				
				if( itemindex > -1 ) {
					items[itemindex].fave = items[itemindex].fave.replace('a1','a2');
				}

				index = faves.indexOf( portfolio );
				if (index > -1) {
					faves.splice(index, 1);
					$.cookie('faves', JSON.stringify( faves ) );
					$('#portfolio-fave-data').data('faves', JSON.stringify( faves ) );
				}
			} else {
				$("span[data-portfolio='" + portfolio + "']").removeClass( 'a2' );
				$("span[data-portfolio='" + portfolio + "']").addClass( 'a1' );

				if( itemindex > -1 ) {
					items[itemindex].fave = items[itemindex].fave.replace('a2','a1');
				}

				index = faves.indexOf( portfolio );
				if (index === -1) {
					faves.push( portfolio );
					$.cookie('faves', JSON.stringify( faves ) );
					$('#portfolio-fave-data').data('faves', JSON.stringify( faves ) );
				}
			}

            var jaxdata = {
                action: 'faveupdate',
                faves: faves
            };
            var succ = function(response,textStatus,XMLHttpRequest) {
            	console.log('success');
			};
            var err = function(XMLHttpRequest, textStatus, errorThrown) {
                alert(textStatus);
            };

            jQuery.ajax({
                type:"POST",
                url:portfoliocoach.ajaxurl,
                data: jaxdata,
                dataType:"json",
                success: succ,
                error: err
            });
		}

		jQuery(document).ready(function($) {
			var domdata = $('#portfolio-fave-data').data('faves');
			if( undefined === domdata || (typeof(domdata) === 'string' && domdata === '[]') ||  (typeof(domdata) === 'object' && domdata.length === 0 ) ){
				var faves = get_favecookie();
				$('#portfolio-fave-data').data('faves', JSON.stringify( faves ) );
			}
		});

        // bind fave stars to click so they can be added to the list of favorites
	    // via ajax
		function fave_bind() {
			$('.fave').unbind();
        	$('.fave').click(function(){
				var portfolio = $(this).data('portfolio');
				if( undefined !== portfolio && '' !== portfolio ) {
					pc_set_fave( portfolio );
				}
			});
		}
		function customDataSource(options, callback) {
          var pageIndex = options.pageIndex;
          var pageSize = options.pageSize;

          var data = items;
		  if (typeof options.sortProperty === 'undefined') {
            options.sortProperty = repeater.data('default-sort');
            options.sortDirection = repeater.data('default-sort-direction');
          }

          // sort by
          data = _.sortBy(data, function(item) {
            if (options.sortProperty === 'category' || options.sortProperty === 'portfolio' || options.sortProperty === 'fave') {
              return item[options.sortProperty];
            }
            return parseFloat(item[options.sortProperty]);
          });

          // sort direction
          if (options.sortDirection === 'desc') {
            data = data.reverse();
          }

          // filter
          if (options.filter && options.filter.value !== 'all') {
            data = _.filter(data, function(item) {
              if (options.filter.value === 'Gold') {
                if (item.category === 'Fundamentals' || item.category === 'Industries' || item.category === 'Sector') {
                  return true;
                }
              }
              if (options.filter.value === 'Silver') {
                if (item.category === 'Industries' || item.category === 'Sector') {
                  return true;
                }
              }
              if (options.filter.value === 'Bronze') {
                if (item.category === 'Sector') {
                  return true;
                }
              }
              return item.category === options.filter.value;
            });
          }

          // search
          if (options.search && options.search.length > 0) {
            var searchedData = [];
            var searchTerm = options.search.toLowerCase();

            _.each(data, function(item) {
              var values = _.values(item);
              var found = _.find(values, function(val) {

                if(val.toString().toLowerCase().indexOf(searchTerm) > -1) {
                  searchedData.push(item);
                  return true;
                }
              });
            });

            data = searchedData;
          }

          var totalItems = data.length;
          var totalPages = Math.ceil(totalItems / pageSize);
          var startIndex = (pageIndex * pageSize) + 1;
          var endIndex = (startIndex + pageSize) - 1;
          if(endIndex > data.length) {
            endIndex = data.length;
          }

          data = data.slice(startIndex-1, endIndex);

          var dataSource = {
            page: pageIndex,
            pages: totalPages,
            count: totalItems,
            start: startIndex,
            end: endIndex,
            columns: columns,
            items: data
          };

          callback(dataSource);

	      fave_bind();
		}
        function initRepeater() {
          // initialize the repeater
          repeater = $('#portfolios-data');
          repeater.repeater({
            list_selectable: false, // (single | multi)
            list_noItemsHTML: '<div class="container"><div class="alert alert-warning" role="alert">Please broaden your search!</div></div>',

            // override the column output via a custom renderer.
            // this will allow you to output custom markup for each column.
            list_columnRendered: customColumnRenderer,

            // override the row output via a custom renderer.
            // this example will use this to add an "id" attribute to each row.
            list_rowRendered: customRowRenderer,

            // setup your custom datasource to handle data retrieval;
            // responsible for any paging, sorting, filtering, searching logic
            dataSource: customDataSource
          });
          // repeater.find('.table').addClass('table-striped');
		  fave_bind();
		}

        $.getJSON('/wp-json/pc/v1/portfolios', function(data) {
          json = data;
        }).complete(function() {
		   var filled = 'a2';
           var faves = get_favedom();
		   var index = -1;
           for(var i = 0; i < json.length; i++) {
			index = faves.indexOf( json[i].Slug );
			if (index > -1) {
				filled = 'a1';
			} else {
				filled = 'a2';
			}

            var item = {
              id: i,
			  fave: '<span class="dashicons dashicons-star-filled ' + filled + ' fave" data-portfolio="' + json[i].Slug + '"></span>',
              subscription: json[i].Subscription,
              url: json[i].URL,
              portfolio: json[i].Name,
              category: json[i].Category,
              current_holdings: json[i].CurrentHoldings.length,
              current_cash_position: parseFloat(json[i].CurrentCashPosition).toFixed(2),
              ytd_return: parseFloat(json[i].YTDReturn).toFixed(2),
              one_year_return: parseFloat(json[i]['1YearReturn']).toFixed(2),
              five_year_return: parseFloat(json[i]['5YearReturn']).toFixed(2),
              return_since_inception: parseFloat(json[i].ReturnSinceInception).toFixed(2),
              annualized: parseFloat(json[i].AllAnnualized).toFixed(2),
              orders: parseInt(json[i].Orders),
			  slug: json[i].Slug
            };
            items.push(item);
          }
          initRepeater();
        });

        $('[data-filter-target]').on('click', function(ev) {
          ev.preventDefault();
          $('.repeater-filters [data-value="' + $(this).data('filter-target') + '"] a').click();
        });
      }
    }
  };

})(jQuery); // Fully reference jQuery after this point.
